<template>
  <table class="table table-bordered table-hover wd-100p" cellspacing="0">
    <thead class="">
      <tr>
        <th rowspan="2" class="text-center">Шалгалтын нэр</th>
        <th colspan="3" class="text-center">Шалгалт</th>
      </tr>
      <tr>
        <th>Өгсөн өдөр</th>
        <th>Авсан оноо</th>
        <th>Тэнцсэн эсэх</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(exam, i) in drawExams" :key="i">
        <td>{{ exam.task }}</td>
        <td>{{ exam.dueStartDate | moment("YYYY/MM/DD") }}</td>
        <td class="text-right">{{ exam.perc }}</td>
        <td>
          {{ getIsTentssen(exam) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
//import { getLast3ExamPoint } from "@/api/learn";
import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";
const moment = require("moment");

var _ = require("lodash");

export default {
  props: {
    locTypeName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      lastExams: [],
      drawExams: [],
      passperc: 100,
      before75: "2021-04-01"
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    getHighPoint(exam) {
      if (
        this.lastExams.filter(
          x => x.isJoined == true && x.locTypeId == exam.locTypeId
        ).length > 0
      ) {
        let sorted = _.orderBy(
          this.lastExams.filter(
            x => x.isJoined == true && x.locTypeId == exam.locTypeId
          ),
          ["perc", "id"],
          ["desc", "desc"]
        );
        return sorted[0];
      } else {
        return "";
      }
    },
    getIsTentssen(exam) {
      if (this.$store.state.app.activeGroup.id == 6126) {
        if (moment(exam.dueStartDate).isBefore(moment(this.before75))) {
          //console.log("4 sariin neg1ss omnoh");
          return exam.perc >= this.passperc ? "тэнцсэн" : "тэнцээгүй";
        } else {
          return exam.perc >= 70 ? "тэнцсэн" : "тэнцээгүй";
        }
      } else {
        if(exam.tentsehHuvi>0){
          return exam.perc >= exam.tentsehHuvi? 'тэнцсэн' : 'тэнцээгүй';
        }
        return exam.perc >= this.passperc ? "тэнцсэн" : "тэнцээгүй";
      }
    },
    init() {
      let hdetmp = getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "onlineExamRegistration_passPerc"
      );
      if (hdetmp != undefined) {
        this.passperc = parseInt(hdetmp, 10);
      }

      let self = this;
      //getLast3ExamPoint({ userId: "" })
      request({
        api: { url: "learn/getLast3ExamPoint", method: "get" },
        params: {
          trackUserId: ""
        },
        store: this.$store
      }).then(res => {
        // console.log(res.data.tasks);
        // this.lastExams = _.orderBy(res.data.tasks, "dueStartDate", "asc");
        this.lastExams = res.data.tasks;
        this.lastExams.forEach((exam, i) => {
          if (
            this.drawExams.filter(x => x.locTypeId == exam.locTypeId).length ==
            0
          ) {
            let add = self.getHighPoint(exam);
            if (add != "") {
              this.drawExams.push(add);
            }
          }
        });
        // console.log('this.drawExams tmz', this.drawExams, this.$props.locTypeValue !== '');
        if (this.$store.state.user.groupId != 6126) {
          if(this.$props.locTypeValue !== ''){
            // this.drawExams = this.drawExams.filter(x => x.parentTaskLocTypeName == this.$props.locTypeName);
          }
        }

        this.drawExams = _.orderBy(this.drawExams, "dueStartDate", "asc");
        this.$emit('on-last-exams', this.drawExams);
      });
    }
  }
};
</script>
